//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiCalendarBlankOutline } from '@mdi/js'

// demos
import ApexChartLineChart from './ApexChartLineChart.vue'
import ApexChartDataScience from './ApexChartDataScience.vue'
import ApexChartNewTechnologiesData from './ApexChartNewTechnologiesData.vue'
import ApexChartBalance from './ApexChartBalance.vue'
import ApexChartStockPrice from './ApexChartStockPrice.vue'
import ApexChartBar from './ApexChartBar.vue'
import ApexChartDailySalesStates from './ApexChartDailySalesStates.vue'
import ApexChartStatistics from './ApexChartStatistics.vue'
import ApexChartMobileComparison from './ApexChartMobileComparison.vue'
import ApexChartExpenseRatio from './ApexChartExpenseRatio.vue'

export default {
  components: {
    ApexChartLineChart,
    ApexChartDataScience,
    ApexChartNewTechnologiesData,
    ApexChartBalance,
    ApexChartStockPrice,
    ApexChartBar,
    ApexChartDailySalesStates,
    ApexChartStatistics,
    ApexChartMobileComparison,
    ApexChartExpenseRatio,
  },
  setup() {
    return {
      icons: {
        mdiCalendarBlankOutline,
      },
    }
  },
}
